import { Table, Box, TableContainer, Paper, Fade, TextField, IconButton, Alert } from '@mui/material';
import React from 'react';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import TablePagination from './TablePagination';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import TableSkeleton from './TableSkeleton';

const ServerDataTable = ({
  data = [],
  columns = [],
  sortConfig = {},
  onSort = () => { },
  noDataMessage = 'No data found',
  currentPage = 0,
  rowsPerPage = 0,
  onPageChange = () => { },
  onRowsPerPageChange = () => { },
  totalRows = 0,
  totalPages = 0,
  rowsPerPageOptions = [10, 25, 50, 100],
  enableSearch = false,
  searchTerm = '',
  setSearchTerm = () => { },
  onClearSearch = () => { },
  searchPlaceholder = 'Search...',
  searchSize = 'small',
  buttons = null,
  loading = false,
  isError = false,
  error = null,
  loadingRows = []
}) => {
  return (
    <Fade in={true} timeout={300}>
      <Box
        sx={{
          position: 'relative',
          minHeight: '200px'
        }}
      >
        {isError ? (
          <Alert severity='error' sx={{ mb: 2, mt: 2, borderRadius: 2 }}>
            {error?.message || 'Error loading data'}
          </Alert>
        ) : loading ? (
          <>
            <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: { xs: 0, sm: 2 }, justifyContent: 'space-between', flexDirection: { xs: 'column', sm: 'row' } }}>
              {enableSearch && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1, justifyContent: 'flex-start', width: { xs: '100% !important', sm: 'auto !important' } }}>
                  <TextField
                    size={searchSize}
                    placeholder={searchPlaceholder}
                    value={searchTerm}
                    onChange={setSearchTerm}
                    sx={{ flex: 1, input: { fontSize: { xs: '14px !important', sm: '16px !important' } } }}
                    InputProps={{
                      startAdornment: <SearchIcon sx={{ color: 'action.active', mr: 1 }} />,
                      endAdornment: (
                        searchTerm ? (
                          <IconButton onClick={onClearSearch}>
                            <ClearIcon />
                          </IconButton>
                        ) : null
                      )
                    }}
                  />
                </Box>
              )}

              {buttons && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: { xs: '100% !important', sm: 'auto !important' } }}>
                  {buttons}
                </Box>
              )}
            </Box>
            <TableSkeleton
              columns={columns}
              pageSize={rowsPerPage}
            />
          </>
        ) : (
          <>
            <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: { xs: 0, sm: 2 }, justifyContent: 'space-between', flexDirection: { xs: 'column', sm: 'row'}}}>
              {enableSearch && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1, justifyContent: 'flex-start', width: { xs: '100% !important', sm: 'auto !important' } }}>
                  <TextField
                    size={searchSize}
                    placeholder={searchPlaceholder}
                    value={searchTerm}
                    onChange={setSearchTerm}
                    sx={{ flex: 1, input: { fontSize: { xs: '14px !important', sm: '16px !important' } } }}
                    InputProps={{
                      startAdornment: <SearchIcon sx={{ color: 'action.active', mr: 1 }} />,
                      endAdornment: (
                        searchTerm ? (
                          <IconButton onClick={onClearSearch}>
                            <ClearIcon />
                          </IconButton>
                        ) : null
                      )
                    }}
                  />
                </Box>
              )}

              {buttons && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: { xs: '100% !important', sm: 'auto !important' } }}>
                  {buttons}
                </Box>
              )}
            </Box>
            <Paper
              elevation={0}
              sx={{
                overflow: 'hidden',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                transition: 'box-shadow 0.2s ease-in-out',
                '&:hover': {
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)'
                }
              }}
            >
              <TableContainer>
                <Table>
                  <TableHeader
                    columns={columns}
                    sortConfig={sortConfig}
                    onSort={onSort}
                  />
                  <TableBody
                    columns={columns}
                    rows={data}
                    noDataMessage={noDataMessage}
                    loadingRows={loadingRows}
                  />
                </Table>
              </TableContainer>
              <Box sx={{ borderTop: 1, borderColor: 'divider' }}>
                <TablePagination
                  currentPage={currentPage}
                  rowsPerPage={rowsPerPage}
                  onPageChange={onPageChange}
                  onRowsPerPageChange={onRowsPerPageChange}
                  totalPages={totalPages}
                  totalRows={totalRows}
                  rowsPerPageOptions={rowsPerPageOptions}
                />
              </Box>
            </Paper>
          </>
        )}

      </Box>
    </Fade>
  );
};

export default ServerDataTable;
